// Newest first. Only the first eligible mounted prompt is shown.
export const USER_EDUCATION_PRIORITY = [
  'agent-saved-prompts',
  'practice-request-snooze',
  'practice-encounters-nav',
  'denials-intelligence-tab',
  'dropbox-item-rename',
  'needs-practice-response-view',
  'uncollectible-claims-moved',
  'account-exclusion-rules',
] as const

export type UserEducationId = (typeof USER_EDUCATION_PRIORITY)[number]
